exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".component---6gaCW {\n  height: 100%;\n  min-width: 1100px; }\n  .component---6gaCW > div {\n    height: 100%; }\n  .component---6gaCW .report-container---3GDg_ {\n    border-top: 1px solid #e1e1e1;\n    padding-top: 16px; }\n  .manage-students-button---DnkpO {\n  background: none;\n  color: #278bcb;\n  text-decoration: underline;\n  border: none;\n  padding: 0;\n  cursor: pointer; }\n", ""]);

// exports
exports.locals = {
	"component": "component---6gaCW",
	"report-container": "report-container---3GDg_",
	"manage-students-button": "manage-students-button---DnkpO"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./containers/skill-quests-mastery/skill-quests-mastery.scss
// module id = KtCJ
// module chunks = 1